export const defaultFeeds = [
  {
    title: "Latest Quantum Computing Breakthroughs",
    description: "Loading latest quantum computing news and updates...",
    link: "#",
    date: new Date().toLocaleDateString(),
    source: "QuantumBytz",
    imageUrl: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb",
    category: "quantum"
  }
];